// App.jsx
import Header from "./components/Header";
import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import theme from "./theme/theme";
import Hero from "./components/Hero";
import AboutMe from "./components/AboutMe";
import SkillsTimeline from "./components/Skills";
import ExperienceTimeline from "./components/Experience";
import Projects from "./components/Projects";
import ContactMe from "./components/ContactMe";
import Footer from "./components/Footer";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <Box
        component="main"
        sx={{
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,

          overflowX: "hidden",
        }}
      >
        <Hero />
        <AboutMe />
        <SkillsTimeline />
        <ExperienceTimeline />
        <Projects />
        <ContactMe />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default App;
